// extracted by css-extract-rspack-plugin
export default {"frame":"frame-o7m7Fz","renderRoot":"renderRoot-Fkgc9C","box":"box-T70G93"};